import React, { useState } from "react";
import { faGlobeAfrica, faGauge, faUsers, faCircleDollarToSlot, faHandHoldingDollar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import AppLayout from "./shared/AppLayout";
import AppAside from "./shared/AppAside";
import AppHeader from "./shared/AppHeader";
import { Outlet } from "react-router-dom";

const navItems = [
  {
    name: "Impact Dashboard",
    path: "/",
    icon: <FontAwesomeIcon className="w-6 h-6" icon={faGauge} />
  },
  {
    name: "Explore",
    path: "/explore",
    icon: <FontAwesomeIcon className="w-6 h-6" icon={faGlobeAfrica} />
  },
  {
    name: "Users",
    path: "/users",
    icon: <FontAwesomeIcon className="w-6 h-6" icon={faUsers} />
  },
  {
    name: "Donations",
    path: "/donations",
    icon: <FontAwesomeIcon className="w-6 h-6" icon={faHandHoldingDollar} />
  },
  {
    name: "Carbon Credit",
    path: "/carbon-credit",
    icon: <FontAwesomeIcon className="w-6 h-6" icon={faCircleDollarToSlot} />
  },
];

const DashboardLayout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  return (
    <AppLayout
      aside={
        <AppAside navItems={navItems} setIsSidebarOpen={setIsSidebarOpen} />
      }
      header={<AppHeader toggleSidebar={toggleSidebar} />}
      main={<Outlet />}
      isSidebarOpen={isSidebarOpen}
    />
  );
};

export default DashboardLayout;
